import { useEffect } from "react";

export function useScrollToTop(deps) {
  return useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, deps || []);
}
